import React, { useState, useEffect, useCallback, useMemo } from 'react';
import axios from 'axios';

import ProjectCard from "../project/ProjectCard";
import Config from "../../config/Config.js";

import { RESOLVE_LOCAL_AUTH_STATE, RESOLVE_LOCAL_USER_STATE } from '../auth/AuthActions';

function OwnedProjects() {
    const auth = useMemo(() => RESOLVE_LOCAL_AUTH_STATE(), []);
    const user = useMemo(() => RESOLVE_LOCAL_USER_STATE(), []);

    const [projects, setProjects] = useState([]);
    const [nextUrl, setNextUrl] = useState(null);
    const [loading, setLoading] = useState(true);
    const [loadingMore, setLoadingMore] = useState(false);
    const [filter, setFilter] = useState('');

    useEffect(() => {
        axios
            .get(`${Config().baseUrl}?owner=${user.pk}&limit=50`)
            .then(res => {
                setProjects(res.data.results);
                setNextUrl(res.data.next?.replace('http://', 'https://'));
                setLoading(false);
            })
            .catch(err => {
                console.error('OwnedProjects error:', err);
                setLoading(false);
            });
    }, [user.pk]);

    const loadMore = useCallback(() => {
        if (!nextUrl || loadingMore) return;
        setLoadingMore(true);
        axios
            .get(nextUrl)
            .then(res => {
                setProjects(prev => [...prev, ...res.data.results]);
                setNextUrl(res.data.next?.replace('http://', 'https://'));
                setLoadingMore(false);
            })
            .catch(err => {
                console.error('OwnedProjects loadMore error:', err);
                setLoadingMore(false);
            });
    }, [nextUrl, loadingMore]);

    if (loading) {
        return <div className="text-center py-4">Loading projects...</div>;
    }

    const q = filter.toLowerCase();
    const filtered = q
        ? projects.filter(p =>
            (p.title || '').toLowerCase().includes(q) ||
            (p.subtitle || '').toLowerCase().includes(q) ||
            (p.technology || '').toLowerCase().includes(q) ||
            (p.skill || '').toLowerCase().includes(q)
          )
        : projects;

    return (
        <div>
            <input
                type="text"
                value={filter}
                onChange={(e) => setFilter(e.target.value)}
                placeholder="Filter projects..."
                style={{
                    width: '100%', padding: '8px 12px', marginBottom: 12,
                    border: '1px solid var(--border)', borderRadius: 'var(--radius-sm)',
                    background: 'var(--surface)', color: 'var(--ink)', fontSize: 14,
                }}
            />
            <div className="row">
                {filtered.map(project => (
                    <ProjectCard project={project} key={project.id} />
                ))}
            </div>
            {nextUrl && (
                <div className="text-center py-3">
                    <button
                        className="btn btn-outline-secondary"
                        onClick={loadMore}
                        disabled={loadingMore}
                    >
                        {loadingMore ? 'Loading...' : 'Load More'}
                    </button>
                </div>
            )}
        </div>
    );
}

export default OwnedProjects;
